import { Component } from '@angular/core';
import { AccordionComponent } from '@/app/components/projects/project-stages/accordion/accordion.component';

@Component({
  selector: 'app-stage2navcall',
  standalone: true,
  imports: [AccordionComponent
  ],
  templateUrl: './stage2navcall.component.html',
  styleUrl: './stage2navcall.component.css'
})
export class Stage2navcallComponent {

}
